(function () {
	window.smap_initContactsMap = function (mapyCz) {
		let point = JSON.parse(mapyCz.element.getAttribute("data-smap-center"));
		let latitude = point[0];
		let longitude = point[1];

		mapyCz.addMarker(latitude, longitude, "Školní jídelna Holice");
	};
})();
